import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /notifications – placeholder until the notifications page is built. */
export const notificationsRoutes: RouteObject = {
  path: 'notifications',
  handle: handle('home'),
  lazy: () =>
    import('@/shared/components/ComingSoonPage').then((m) => ({ Component: m.ComingSoonPage })),
};
